(ns frontend.ui.component.lp-portal.report.body.real-estate.fund.nre.web.view.tearsheet
  (:require
   [frontend.ui.component.grid.view :as grid]
   [frontend.ui.component.lp-portal.report.tearsheet.portfolio-locations.view
    :refer [portfolio-locations-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.return-development.view
    :refer [return-development-card]]
   [frontend.ui.component.lp-portal.section.view :refer [section]]
   [frontend.ui.component.lp-portal.report.tearsheet.basic-information.view
    :refer [basic-information-card]]
   [frontend.ui.component.lp-portal.report.tearsheet.largest-investments-at-fair-value.view :as
    largest-investments]))

(defn tearsheet-section
  [tearsheet props]
  (let [{:keys [largest-investment-by-nav portfolio-locations]} tearsheet]
    [section
     "Tear sheet"
     (str "tearsheet-"
          (some->> props
                   :report
                   :db/id))
     [:div
      [grid/row {}
       [grid/column {:large 6}
        [return-development-card tearsheet props]]
       [grid/column {:large 6}
        [largest-investments/largest-investments-by-NAV largest-investment-by-nav props]
        [portfolio-locations-card portfolio-locations props]]]
      [:div
       [basic-information-card tearsheet props]]]]))
